"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var breakpoints = _ref.breakpoints,
      palette = _ref.palette,
      spacing = _ref.spacing,
      typography = _ref.typography;
  return {
    root: {
      width: "100%"
    },
    section: {},
    about: {
      display: "block"
    },
    aboutAbout: {},
    aboutInitiative: {
      display: "block",
      marginTop: "1.5rem"
    },
    divider: {
      backgroundColor: palette.secondary.main,
      height: 2
    },
    dividerDesktop: _defineProperty({
      display: "none"
    }, breakpoints.up("md"), {
      display: "flex",
      marginLeft: spacing(2)
    }),
    dividerMobile: {
      order: 3
    },
    grow: {
      flexGrow: 1
    },
    organization: _defineProperty({
      marginBottom: "2.243125rem"
    }, breakpoints.up("md"), {
      marginBottom: "4.305625rem"
    }),
    organizationLogo: _defineProperty({
      width: "13.875rem",
      height: "auto"
    }, breakpoints.up("md"), {
      width: "18.3175rem"
    }),
    supporterLogo: _defineProperty({
      width: "9.6275rem",
      height: "auto"
    }, breakpoints.up("md"), {
      width: "13.7375rem"
    }),
    support: _defineProperty({
      display: "block",
      marginBottom: "1.618125rem",
      marginTop: "1.708rem"
    }, breakpoints.up("md"), {
      display: "none"
    }),
    quickLinksMore: _defineProperty({
      marginTop: "2.881875rem",
      order: 4
    }, breakpoints.up("md"), {
      marginTop: 0,
      order: 3
    }),
    quickLinksContact: _defineProperty({
      marginTop: "2.881875rem",
      order: 5
    }, breakpoints.up("md"), {
      marginTop: 0,
      order: 4
    }),
    initiative: _defineProperty({
      order: 2
    }, breakpoints.up("md"), {
      order: 5
    }),
    copyright: _defineProperty({
      marginTop: "1.618125rem",
      order: 3,
      textAlign: "center"
    }, breakpoints.up("md"), {
      marginTop: 0,
      order: 2
    }),
    copyrightLogo: {
      marginLeft: "0.80375rem",
      verticalAlign: "middle"
    },
    legal: _defineProperty({
      order: 2
    }, breakpoints.up("md"), {
      order: 3
    }),
    legalLinks: {},
    legalLinksLink: {},
    legalLinksList: {},
    primary: _defineProperty({
      paddingBottom: typography.pxToRem(59)
    }, breakpoints.up("md"), {
      paddingBottom: typography.pxToRem(120.89)
    }),
    secondary: _defineProperty({
      backgroundColor: palette.secondary.main,
      border: "1px solid #707070",
      color: palette.text.secondary.main,
      paddingBottom: "2.381875rem",
      paddingTop: "4.194375rem"
    }, breakpoints.up("md"), {
      paddingBottom: "4.194375rem",
      paddingTop: "5.375rem"
    }),
    stayInTouch: {},
    stayInTouchIcon: {},
    stayInTouchLink: {},
    stayInTouchLinks: {},
    stayInTouchText: {},
    stayInTouchTitle: {},
    text: {}
  };
});
var _default = useStyles;
exports["default"] = _default;